import { BehaviorSubject } from 'rxjs';
import HistoricalModuleType from '../enums/historicalModuleType';
export const getDisplayHistoricalModuleStore = () => {
    const getInitialState = () => {
        const historicalModuleTypeTablesInitialState = {
            summary: {
                items: [],
                total: {
                    baseValues: null,
                    calculationYears: []
                }
            },
            deductedValuesForYear: {
                items: [],
                total: null
            },
            deductibleValuesAfterYear: {
                items: [],
                total: null
            }
        };
        return {
            historicalModuleDetails: {
                companyName: '',
                currentCalculationYear: null,
                availableCalculationYears: [],
                currentCalculationYearFieldsModel: {},
                tablesDetails: {
                    [HistoricalModuleType.FiscalLoss]: historicalModuleTypeTablesInitialState,
                    [HistoricalModuleType.ExcessCost]: historicalModuleTypeTablesInitialState,
                    [HistoricalModuleType.SponsorshipExpenses]: historicalModuleTypeTablesInitialState
                }
            },
            isLoading: true
        };
    };
    const subject = new BehaviorSubject(getInitialState());
    const subscribe = (callback) => subject.subscribe(callback);
    const setHistoricalModuleDetails = (details) => subject.next({
        historicalModuleDetails: details,
        isLoading: false
    });
    const reset = () => subject.next(getInitialState());
    return {
        getInitialState,
        setHistoricalModuleDetails,
        reset,
        subscribe
    };
};
